/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cddf9d42850334b7932bd90cf51a8b1f>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UNSAFE_baseNew = _interopRequireDefault(require("@atlaskit/icon/UNSAFE_base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const FieldTextIcon = props => /*#__PURE__*/_react.default.createElement(_UNSAFE_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75h2.5m2.5 0h-2.5m0 0v3.5m0 9H8m2.5 0H13m-2.5 0v-3.5m0-5.5H14c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-3.5m0-5.5v5.5M8 5.25H2c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25h6"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
FieldTextIcon.displayName = 'FieldTextIcon';
var _default = exports.default = FieldTextIcon;